import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './index.css'
import 'katex/dist/katex.min.css'; // <--- ADD THIS LINE

createApp(App).use(router).mount('#app')
